var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Icon } from './Icon';
export var SearchIcon = function (props) { return (React.createElement(Icon, __assign({}, props),
    React.createElement("path", { d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14zm6-1.708l5.854 5.854a.5.5 0 0 1-.708.708l-5.854-5.855a8 8 0 1 1 .707-.707z" }))); };
//# sourceMappingURL=SearchIcon.js.map